export const prepareCartId = (responseObject) => {
    const { __typename, period, type } = responseObject;
    // console.log(responseObject);
    if (!period || !type) {
        console.error('period:', period, 'type:', type);
    }
    return `${__typename}:${type}:${period}`;
};

